import { isStringOrEncryptedField } from '@/infra/sse/shared/decryption'
import type { RawConversationEventPayload } from './types'

export const isRawConversationEventPayload = (obj: unknown): obj is RawConversationEventPayload => {
  if (typeof obj !== 'object' || obj === null) return false
  const candidate = obj as Record<string, unknown>

  if (typeof candidate['eventType'] !== 'string') return false

  // rawHookPayload: null, undefined (missing), or non-array object
  const rawPayload = candidate['rawHookPayload']
  if (rawPayload !== null && rawPayload !== undefined) {
    if (typeof rawPayload !== 'object' || Array.isArray(rawPayload)) return false
  }

  // eventMetadata: required object with shared field validation
  const meta = candidate['eventMetadata']
  if (typeof meta !== 'object' || meta === null) return false
  const m = meta as Record<string, unknown>
  if (
    typeof m['timestamp'] !== 'string' ||
    typeof m['userExternalId'] !== 'string' ||
    typeof m['claudeSessionId'] !== 'string' ||
    typeof m['eventId'] !== 'string' ||
    typeof m['userPromptId'] !== 'string' ||
    !isStringOrEncryptedField(m['transcriptPath']) ||
    !isStringOrEncryptedField(m['contextWorkDirectory'])
  )
    return false

  // hostDetails + telemetry: required objects
  if (typeof candidate['hostDetails'] !== 'object' || candidate['hostDetails'] === null)
    return false
  if (typeof candidate['telemetry'] !== 'object' || candidate['telemetry'] === null) return false

  // rawNotificationContext + agentResponse: any type (null, encrypted, object, string) — no validation
  return true
}
